import { Injectable } from '@angular/core';

import { RoutingService, GlobalMessageService, User, GlobalMessageType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, pluck, map } from 'rxjs/operators';
import {UserAccountFacade} from '@spartacus/user/account/root';

@Injectable({
    providedIn: 'root',
})
export class UigShopViewGuard  {

    ROLE_SHOPVIEW_USER = 'ROLE_SHOPVIEW_USER';
    ROLE_SHOPVIEW = 'ROLE_SHOPVIEW';

    constructor(
        protected userAccountFacade: UserAccountFacade,
        protected routingService: RoutingService,
        protected globalMessageService: GlobalMessageService
    ) { }

    canActivate(): Observable<boolean> {
        return this.userAccountFacade.get().pipe(
            filter((user: User) => user && Object.keys(user).length > 0),
            pluck('authorities'),
            map((authorities: string[]) => {
                const hasRole =
                    ((authorities && Array.isArray(authorities)) && (authorities.includes(this.ROLE_SHOPVIEW) || authorities.includes(this.ROLE_SHOPVIEW_USER)));
                if (hasRole) {
                    // routing as temporary solution until /organization won't
                    // have set up proper permission on backend
                    this.routingService.go({ cxRoute: 'home' });

                    this.globalMessageService.add(
                        { key: 'organization.notification.noSufficientPermissions' },
                        GlobalMessageType.MSG_TYPE_WARNING
                    );
                }
                return !hasRole;
            })
        );
    }
}
